export default "__VITE_ASSET__2faa5fbb__"